import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getDatePickerTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      daterange_picker: {
        start: 'RANGE_START',
        end: 'RANGE_END',
      },
    },
  }));
}

export function getDropDownTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      select_with_search: {
        no_data: 'NO_DATA',
        no_matches: 'NO_MATCHES',
        search_placeholder: 'PLACEHOLDER',
      },
    },
  }));
}

export function getFileUploadTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      upload_file: {
        cancel: 'CANCEL',
        choose_file: 'CHOOSE_FILE',
        errors_in_file: 'ERROR_IN_FILE',
        invalid_file_size: 'INVALID_FILE_SIZE',
        invalid_file_format: 'INVALID_FILE_FORMAT',
        title: 'TITLE',
        upload: 'UPLOAD',
      },
    },
  }));
}

export function getMultiSelectTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      checkboxes_list: {
        check_all: 'CHECK_ALL',
        clear_all: 'CLEAR_ALL',
        from: 'FROM',
        import_from_csv: 'IMPORT_FROM_CSV',
        no_data: 'NO_DATA',
        selected: 'SELECTED',
      },
    },
  }));
}

export function getFormCommonTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    common: {
      errors: {
        form: {
          required: 'ERROR_REQUIRED',
          invalid: 'ERROR_INVALID',
        },
      },
    },
  }));
}
